import type { ReactNode } from 'react'

export function SettingRow({
  label,
  help,
  children,
}: {
  /** ReactNode, not string: a keyboard shortcut's label is a `<kbd>`. */
  label: ReactNode
  help?: string
  children?: ReactNode
}) {
  return (
    // Below tablet it stacks: a label and its value at opposite ends of a
    // 1400px monitor is a row you have to track across with a finger.
    <div className="flex min-h-touch flex-col items-start justify-between gap-3 px-5 py-4 not-first:border-t not-first:border-line-soft sm:flex-row sm:items-center sm:gap-5">
      <div className="min-w-0">
        <div className="text-sm font-semibold">{label}</div>
        {help && (
          <div className="mt-0.5 max-w-[60ch] text-xs leading-snug text-fg-muted">{help}</div>
        )}
      </div>
      {children && (
        <div className="flex w-full flex-none items-center gap-2 text-left sm:w-auto sm:text-right">
          {children}
        </div>
      )}
    </div>
  )
}
